<script>

import { Radar } from 'vue-chartjs'

export const info = '<b>Project</b>: Your number of Open Innovation projects<br>' +
  '<b>Science</b>: Your number of \'Science\' searches on the platform<br>' +
  '<b>Patent</b>: Your number of \'Patent\' searches on the platform<br>' +
  '<b>Company</b>: Your number of \'Company\' searches on the platform<br>' +
  '<b>News</b>: Your number of \'News\' searches on the platform<br>' +
  '<b>AI Chat</b>: Your number of \'AI Chat\' searches on the platform<br>' +
  '<b>Monitor</b>: Your number of monitored queries<br>' +
  '<b>Biblio</b>: The number of boxes saved in your biblios<br>' +
  '<b>Expert</b>: The number of experts saved in your projects<br>' +
  '<b>Question</b>: The number of reviewed questions (validated) on the platform<br>' +
  '<b>Mailing</b>: The number of mailings sent to experts via the platform<br>' +
  '<b>Interact</b>: The number of interactions through the platform<br>' +
  '<b>Report</b>: number of documents exported in pdf from the platform<br>' +
  '<b>Collaborate</b>: Your number of shared projects, shared publications and upload documents to another system (if available)<br>' +
  '<b>Contribute</b>: Your number of \'Edit data\' contributions<br>'

export default {
  extends: Radar,
  components: {
  },
  props: ['stats'],
  name: 'IdxRadar',
  data () {
    return {
      options: {
        legend: {
          display: false
        },
        responsive: true,
        scale: {
          reverse: false,
          ticks: {
            stepSize: 10,
            min: 0,
            max: 100
          }
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return tooltipItems.yLabel + ' %'
            }
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      data: {
        datasets: [{
          backgroundColor: 'rgba(52, 152, 219, 0.4)',
          borderColor: 'rgba(52, 152, 219 ,1)',
          pointBackgroundColor: 'rgba(52, 152, 219 ,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: 'rgba(52, 152, 219, 0.4)',
          pointHoverBorderColor: '#3498db',
          borderWidth: 1,
          data: [20, 80, 60, 30, 70, 20, 10]
        }],
        labels: []
      }
    }
  },
  methods: {
    draw: function () {
      let radarValues = []
      let radarLabels = []
      Object.keys(this.stats).forEach((element) => {
        radarLabels.push(element)
        radarValues.push(this.stats[element])
      })
      this.data.datasets[0].data = radarValues
      this.data.labels = radarLabels

      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.draw()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/IdxRadar.vue